module.exports = __webpack_public_path__ + "img/map.aa389b4c.svg";